const typeLabels = {
  standard: 'Estándar',
  simon: 'Simon dice',
  statues: 'Estatuas',
  music_styles: 'Estilos musicales',
  intervals: 'Intervalos',
  narrative: 'Narrativo'
}

const intensityLabels = {
  low: 'Suave',
  mid: 'Media',
  high: 'Alta'
}

const focusLabels = {
  full: 'Cuerpo entero',
  upper: 'Tren superior',
  low_body: 'Tren inferior',
  core: 'Core'
}

export function typeLabel(type) {
  return typeLabels[type] || type
}

export function intensityLabel(intensity) {
  return intensityLabels[intensity] || intensity
}

export function focusLabel(focus) {
  return focusLabels[focus] || focus
}

export function formatDuration(seconds) {
  const total = Math.max(0, Math.round(seconds))
  const minutes = Math.floor(total / 60)
  const rest = total % 60

  return `${minutes}:${String(rest).padStart(2, '0')}`
}
